import React from 'react';
import { PreviewImage } from './PreviewImage';
import { LogoWithButtons } from './LogoWithButtons';
import { largeMargin } from '../margins';
import { getWindow } from '../globals';

export class Hero extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: '80vh',
    };
  }

  componentDidMount() {
    let window = getWindow();
    if (window) {
      this.setState({
        height: window.innerHeight * 0.8 + 'px',
      });
    }
  }

  render() {
    const {
      hero,
      logo,
      primaryButton,
      leftButton,
      className,
      ...restProps
    } = this.props;

    const { preview, aspectRatio, url: heroSrc, alt, cloudinary } = hero;

    return (
      <div
        css={`
          position: relative;
          margin-bottom: ${largeMargin};
          ${className};
        `}
        {...restProps}
      >
        <PreviewImage
          src={heroSrc}
          alt={alt}
          cloudinaryOptions={{ extra: 'b_black,o_60', ...cloudinary }}
          aspectRatio={aspectRatio}
          preview={preview}
          height={this.state.height}
        />
        <div
          css={`
            display: flex;
            justify-content: center;
            position: absolute;
            bottom: 0;
            top: 0;
            right: 0;
            left: 0;
            z-index: 2;
          `}
        >
          <LogoWithButtons
            logo={logo}
            primaryButton={primaryButton}
            leftButton={leftButton}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Hero.js